import './timeZoneSelect.scss'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Dropdown } from 'ui_kit_qmd'
import { getDefaultTimeZoneAbbreviation, getTimeZones, uniqueByField } from '../../utils/common'

const selectVisitTypeDropdownContainerStyle = {
  width: 300,
  height: 42,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  border: '1px solid #C2D5E2',
  borderStyle: 'solid',
  background: '#FFFFFF',
  marginLeft: 0,
  paddingLeft: 0,
}

const selectVisitTypeDropdownListContainerStyle = {
  width: 670,
  marginTop: 8,
  height: 234,
  left: -370,
  zIndex: 999999999,
}
const dropdownSearchContainerStyle = {
  width: 'calc(100% - 32px)',
}
const selectVisitTypeDropdownIconStyle = {
  top: 12,
  right: 13,
}

const selectVisitTypeDropdownInputStyle = {
  padding: 0,
  margin: '0px 0px 0px 10px',
  height: 28,
  width: 260,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const TimeZoneSelect = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSetCurrentDateTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    customSelectedTimezone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    containerStyle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    label = '',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    selectedOptionStyle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    arrowStyle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dropDownContainerStyle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    useDefault,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isWithDynamicParentAdjustements,
  }) => {
    const timezones = getTimeZones(allTimezones)
    const { options, parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'quickMd' })
    const uniqByLabelOptions = uniqueByField(options, 'label')

    const currentSystemTzObject =
      customSelectedTimezone ?
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        parseTimezone(customSelectedTimezone === 'UTC' ? getDefaultTimeZoneAbbreviation() : customSelectedTimezone)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      : parseTimezone(getDefaultTimeZoneAbbreviation())

    const firstRenderTimezoneAbbr = currentSystemTzObject?.label?.replace('GMT', 'UTC')

    const [selectedTimezone, setSelectedTimezone] = useState(
      useDefault && !customSelectedTimezone ?
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        `Use system setting ${parseTimezone(getDefaultTimeZoneAbbreviation()).label}`
      : firstRenderTimezoneAbbr,
    )

    useEffect(() => {
      if (isWithDynamicParentAdjustements && customSelectedTimezone) {
        setSelectedTimezone(firstRenderTimezoneAbbr)
      }
    }, [customSelectedTimezone])

    const setOptions = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        setSelectedTimezone(value)
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const newTimeZoneObject = uniqByLabelOptions.find((opt) => opt.label.replace('GMT', 'UTC') === value)
        onSetCurrentDateTimeZone(newTimeZoneObject)
      },
      [onSetCurrentDateTimeZone, uniqByLabelOptions],
    )

    const correctOptionsList = useMemo(() => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      if (!useDefault) return uniqByLabelOptions.map((t) => t?.label?.replace('GMT', 'UTC'))

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const newOptions = uniqByLabelOptions.map((t) => t?.label?.replace('GMT', 'UTC'))
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      newOptions.unshift(`Use system setting ${parseTimezone(getDefaultTimeZoneAbbreviation()).label}`)
      return newOptions
    }, [uniqByLabelOptions, parseTimezone, useDefault])

    return (
      <div>
        <Dropdown
          isWithSearch
          dropdownSearchContainerStyle={dropdownSearchContainerStyle}
          options={correctOptionsList}
          isWithoutLabel={!label}
          containerStyle={containerStyle || selectVisitTypeDropdownContainerStyle}
          customIconStyles={arrowStyle || selectVisitTypeDropdownIconStyle}
          inputStyle={selectedOptionStyle || selectVisitTypeDropdownInputStyle}
          dropdownContainerStyle={dropDownContainerStyle || selectVisitTypeDropdownListContainerStyle}
          value={selectedTimezone}
          setValue={setOptions}
          dropId='ViewDropDown'
          label={label}
          isAutoRowHeight
        />
      </div>
    )
  },
)

export default TimeZoneSelect
